import reduceReducers from "reduce-reducers";
import BaseReducer from "../../../../esshop2_frontend/src/js/reducers";

const rootReducer = reduceReducers(
	BaseReducer
);

export default rootReducer;
